// Extension-related URLs
export const EXTENSION_URLS = {
  CHROME_WEB_STORE: 'https://chromewebstore.google.com/detail/findem-extension/enblpljehpbnlkmncfljkphdmiaejgll?hl=en&pli=1',
  LEARN_MORE_RRA: 'https://findem.gitbook.io/russell-reynolds-x-findem/people-finder/getting-started/how-to-shortlist-a-candidate-directly-from-linkedin',
  LEARN_MORE_EXEC: 'https://findem.zendesk.com/hc/en-us/articles/4409598628503-How-to-shortlist-a-candidate-directly-from-LinkedIn',
} as const;

// External service URLs
export const EXTERNAL_URLS = {
  FINDEM_WEBSITE: 'https://www.findem.ai',
  PRIVACY_POLICY: 'https://www.findem.ai/privacy-policy',
  SECURITY_ISSUE: 'https://www.findem.ai/report-security-issue',
} as const;

// Help and documentation URLs
export const HELP_URLS = {
  EXEC_HELP_CENTER: 'https://execsearchfindem.zendesk.com/hc/en-us',
  RRA_LMS: 'https://rra.litmos.com/home/LearningPath/610786',
  SUBMIT_REQUEST: 'https://wkf.ms/3vDVKyH',
} as const;
